import { useMutation, useQueryClient } from '@tanstack/react-query';
import noop from 'lodash-es/noop';

import {
  addCartProduct,
  optimizeSpecials,
  removeCartProduct,
  updateCartProducts,
} from './cartProducts.api';
import type { UseCartProductParams } from './cartProducts.type';

export const useOptimizeSpecials = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: optimizeSpecials,
    onSuccess: (cart) => {
      queryClient.setQueryData(['cart', cart.uuid], cart);
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['posCart'] });
    },
  });
};

export const useAddCartProduct = ({
  onSuccess = noop,
  onError = noop,
}: UseCartProductParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addCartProduct,
    onError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['posCart'] });

      onSuccess();
    },
  });
};

export const useRemoveCartProduct = ({
  onSuccess = noop,
  onError = noop,
}: UseCartProductParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: removeCartProduct,
    onError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['posCart'] });

      onSuccess();
    },
  });
};

export const useUpdateCartProduct = ({
  onSuccess = noop,
  onError = noop,
}: UseCartProductParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCartProducts,
    onError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      queryClient.invalidateQueries({ queryKey: ['posCart'] });

      onSuccess();
    },
  });
};
